module.exports = __webpack_public_path__ + "static/img/ZM.dcf549ed.png";